import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-summary-file-field',
  templateUrl: './summary-file-field.component.html',
  styleUrls: ['./summary-file-field.component.scss']
})
export class SummaryFileFieldComponent {

  @Input() element: any;
}
